import {lazy} from 'react';

const UserManagement = lazy(() => import('./UserManagement'));

export default UserManagement;
